<app-modal-basic modalContentId="produtos-agricolas" #modalAgricula (closed)="closed.emit(false)" [showNow]="open"
  (opened)="onOpened()" [dialogClass]="'modal-lg'">

  <div class="app-modal-header">
    <h3 class="modal-title">
      Informações de Produtos da Agricultura, Pecuária e Florestal
    </h3>
  </div>

  <div class="app-modal-body">
    <app-dim-tabswipe #appTab [inputs]="tabs">
      <mat-tab-group animationDuration="400ms" [selectedIndex]="currentTabIndex" mat-stretch-tabs="false"
        mat-align-tabs="start" mat-stretch-tabs="true" (selectedIndexChange)="onSelectedIndexChange($event)">

        <mat-tab *ngFor="let tab of tabs; let i = index" [disabled]="isTabBlocked(i)">
          <ng-template mat-tab-label>
            <span [ngbTooltip]="isTabBlocked(i) ? 'aba bloqueada' : null" [attr.aria-disabled]="isTabBlocked(i)">
              {{ tab }}
            </span>
          </ng-template>

          <!-- Conteúdo da Aba Guia de Trânsito -->
          <ng-container *ngIf="i === 0">
            <div class="dim-tabswipe-content" [formGroup]="form">
              <div class="row">
                <div class="form-group col-sm-6">
                  <label class="required">Tipo da Guia</label>
                  <ng-select appendTo="#produtos-agricolas" [items]="tipoGuiaOptions" bindLabel="label" bindValue="value"
                    formControlName="tipoGuia"></ng-select>
                </div>

                <div class="form-group col-sm-6">
                  <label class="required">UF da Guia</label>
                  <ng-select appendTo="#produtos-agricolas" [items]="estadosOptions" bindLabel="nome" bindValue="id"
                    formControlName="ufGuia"></ng-select>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm-6">
                  <label>Série da Guia</label>
                  <input type="text" formControlName="serieGuia" class="form-control" maxlength="8" mask="0{8}">
                </div>

                <div class="form-group col-sm-6">
                  <label class="required">Número da Guia</label>
                  <input type="text" formControlName="numeroGuia" class="form-control" maxlength="8" mask="0{8}">
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Conteúdo da Aba Defensivo -->
          <ng-container *ngIf="i === 1">
            <div class="dim-tabswipe-content">
              <form [formGroup]="formDefensivo">
                <div class="row">
                  <div class="form-group col-sm-5">
                    <label>Nr. Receituário</label>
                    <input type="text" formControlName="nReceituario" class="form-control" maxlength="30" style="text-align: left">
                  </div>
                  <div class="form-group col-sm-5">
                    <label>CPF Resp. Tec.</label>
                    <input type="text" formControlName="cpfRespTec" class="form-control" style="text-align: left"
                    mask="000.000.000-00">
                  </div>
                  <div class="form-group col-sm-2 d-flex align-items-end">
                    <button (click)="adicionarDefensivo()" class="btn btn-info btn-new-item btn-same-height">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
              </form>

              <!-- Grid do Defensivo -->
              <div class="row">
                <div class="col table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Número do Receituário</th>
                        <th>CPF Responsável</th>
                        <th *ngIf="listaDefensivo.length > 0">
                          <button type="button" class="btn btn-danger btn-mini" ngbTooltip="Remover todos"
                            (click)="removerTodos()">
                            <i class="ti ti-trash"></i>
                          </button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let defensivo of listaDefensivo; let index = index">
                        <td>{{ defensivo.nReceituario }}</td>
                        <td>{{ defensivo.cpfRespTec | cnpjcpf }}</td>
                        <td>
                          <button type="button" class="btn btn-danger btn-mini" ngbTooltip="Remover"
                            (click)="remover(index)">
                            <i class="ti ti-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot *ngIf="listaDefensivo.length === 0">
                      <tr>
                        <td colspan="3"><span class="text-center">Nenhum defensivo informado!</span></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </ng-container>

        </mat-tab>
      </mat-tab-group>
    </app-dim-tabswipe>


    <div class="row mt-3">
      <div class="col">
        <button type="button" (click)="salvar()" class="btn btn-primary">
          Salvar
        </button>
        <button type="button" (click)="modalAgricula.hide()" class="btn btn-danger">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</app-modal-basic>
